import { Route, Routes } from 'react-router-dom';
import { AssetsContext, AssetsTypes } from './AssetsTypes';
import { CollectionsPage } from '../CollectionsPage/CollectionsPage';
import { AchievementsPage } from '../AchievementsPage/AchievementsPage';
import { BoostsPage } from '../BoostsPage/BoostsPage';
import { RatingsPage } from '../RatingsPage/RatingsPage';

export const AssetsRoutes = () => {
    return (
        <Routes>
            <Route path='/' element={<AssetsTypes />} />

            <Route path={ `/${AssetsContext.Boosts}` } element={ <BoostsPage /> } />
            <Route path={ `/${AssetsContext.Collections}` } element={ <CollectionsPage /> } />
            <Route path={ `/${AssetsContext.Ratings}` } element={ <RatingsPage /> } />
            <Route path={ `/${AssetsContext.Achievements}` } element={ <AchievementsPage /> } />
        </Routes>
    );
};